import { AfterViewInit, Directive, ElementRef, inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[promoBannerOffset]',
  standalone: true
})
export class PromoBannerOffsetDirective implements AfterViewInit, OnDestroy {
  private readonly elRef = inject(ElementRef<HTMLElement>);
  private readonly platformId = inject(PLATFORM_ID);

  private resizeObserver!: ResizeObserver;

  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) return;

    this.updateCssVariable();

    this.resizeObserver = new ResizeObserver(() => {
      this.updateCssVariable();
    });

    this.resizeObserver.observe(this.elRef.nativeElement);
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      this.resizeObserver.disconnect();
    }
  }

  updateCssVariable() {
    const height = this.elRef.nativeElement.offsetHeight;
    document.documentElement.style.setProperty('--promo-banners-height', `${height}px`);
  }
}
